import InfoRow from "./InfoRow";

export default function ClientDetailsTab({ client }) {
  return (
    <section className="space-y-4">
      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-3 text-sm font-semibold text-slate-900">Algemene gegevens</h3>
        <InfoRow label="Bedrijfsnaam" value={client.bedrijfsnaam} />
        <InfoRow label="Klantnummer" value={client.klantnummer} />
        <InfoRow label="Klanttype" value={client.klanttype} />
        <InfoRow label="Status" value={client.status} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-3 text-sm font-semibold text-slate-900">Administratieve gegevens</h3>
        <InfoRow label="Factuuradres" value={client.factuuradres} />
        <InfoRow label="KVK-nummer" value={client.kvkNummer} />
        <InfoRow label="BTW-nummer" value={client.btwNummer} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-3 text-sm font-semibold text-slate-900">Communicatie en labels</h3>
        <InfoRow label="Hoofdcontact" value={client.hoofdcontactpersoon} />
        <InfoRow label="Telefoon" value={client.telefoon} />
        <InfoRow label="E-mail" value={client.email} />
        <InfoRow label="Interne labels" value={client.labels.join(", ")} />
      </div>

      <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-5 text-sm text-slate-600">
        Externe koppelingen (placeholder): Moneybird relatie-ID {client.moneybirdRelatieId}
      </div>
    </section>
  );
}
